<template>
  <div id="app">
    <SiteShell />
  </div>
</template>

<script>
import SiteShell from './components/site/SiteShell.vue'

export default {
  name: 'App',
  components: {
    SiteShell
  }
}
</script>

<style lang="less">
@primary: #2463eb;
@primary-dark: #1a49b2;
@text: #0f172a;
@muted: #64748b;

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  background: radial-gradient(circle at 5% 0%, #f2f7ff 0%, #f8fbff 42%, #f2f5fb 100%);
  color: @text;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100vh;
}

a {
  color: inherit;
}

.reveal {
  opacity: 1;
  transform: none;
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.reveal.reveal-pending {
  opacity: 0;
  transform: translateY(22px);
}

.reveal.in-view {
  opacity: 1;
  transform: translateY(0);
}

.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.tab-fade-enter,
.tab-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
